import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';

import { ContactsLinkedInSync } from 'pages/contactsLinkedInSync';
import { AllyCompletionMessage } from './components/AllyCompletionMessage';
import AllySignupLayout from './components/AllySignupLayout';
import { SignUp } from './components/signUp';
import { Profile } from './components/profile';
import { AllyIntegrations } from './components/integrations';
import { LoggedInAlly } from './components/loggedInAlly';
import { useAllySignup } from './hooks/useAllySignup';

export const AllySignup = () => {
  const { path } = useRouteMatch();
  const {
    user,
    network,
    url,
    onboardingSteps,
    currentStepIndex,
    steps,
    isShareContactsRoute,
    isShareContactsLoading,
    handleShareContacts,
    shouldRedirectToStayTuned,
    shouldRedirectToHome,
    shouldRedirectToShareContacts,
    shareContactsRedirectUrl,
  } = useAllySignup();

  if (shouldRedirectToStayTuned) {
    return <Redirect to="/stay-tuned" />;
  }

  if (shouldRedirectToHome) {
    return <Redirect to="/" />;
  }

  if (shouldRedirectToShareContacts) {
    return <Redirect to={shareContactsRedirectUrl} />;
  }

  return (
    <AllySignupLayout
      network={network}
      onboardingSteps={isShareContactsRoute ? null : onboardingSteps}
      currentStepIndex={currentStepIndex}
      steps={steps}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: '160px',
          flex: 1,
          height: '100%',
        }}
      >
        <Switch>
          <Route exact path={`${path}`}>
            <Box maxWidth="400px" m="0px auto" pb="40px">
              <SignUp routePath={url} network={network} />
            </Box>
          </Route>
          <Route exact path={`${path}/profile/:mode`}>
            <Box maxWidth="400px" m="0px auto" pb="40px">
              <Profile user={user} network={network} />
            </Box>
          </Route>
          <Route exact path={`${path}/integrations`}>
            <Box minWidth="600px" maxWidth="600px" m="0px auto" pb="40px">
              <AllyIntegrations network={network} />
            </Box>
          </Route>
          <Route exact path={`${path}/complete`}>
            <Box maxWidth="400px" m="0px auto" pb="40px">
              <AllyCompletionMessage network={network} />
            </Box>
          </Route>
          <Route exact path={`${path}/linkedin/:action`}>
            <ContactsLinkedInSync isAllyOnboarding />
          </Route>
          <Route exact path={`${path}/share-contacts`}>
            <Box maxWidth="400px" m="0px auto" pb="40px">
              <LoggedInAlly
                network={network}
                user={user}
                onShareContacts={handleShareContacts}
                isShareContactsLoading={isShareContactsLoading}
              />
            </Box>
          </Route>
        </Switch>
      </Flex>
    </AllySignupLayout>
  );
};

export default AllySignup;
